module.exports = __webpack_public_path__ + "img/img-shadow.a43f023d.svg";